export const readEmpty = async (skip,user) => {
    try{
        const res = await fetch( 
            `${process.env.REACT_APP_BACKEND_URL}/listReminderPayment?skip=${skip}&user=${user}`,
            {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            }
        );
        const data = await res.json();
        // Check for errors in response
        if (res.status >= 400) {
            throw new Error(data.errors || 'Something went wrong');
        }
        // return data and error
        return { data, error: null };
    } catch(error){
        throw new Error(error);
    }
}